// extracted by mini-css-extract-plugin
export default {"notifications-mapper":"bLZhkk","list":"MpaJsn","notifications-mapper_expanded":"tBfe_F","show":"gVFg5I"};